/** @format */

import React from "react";

export default () => (
  <svg
    width="32"
    height="25"
    viewBox="0 0 32 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="25" fill="#F5F5F5" />
    <g clip-path="url(#clip0_0_1)">
      <rect
        width="1366"
        height="6126"
        transform="translate(-571 -785)"
        fill="white"
      />
      <path d="M-571 -685H948V5070H-571V-685Z" fill="#F9F7F2" />
      <path d="M-567 -685H799V3813H-567V-685Z" fill="#F9F7F2" />
      <path d="M-317 -345H799V3813H-317V-345Z" fill="#F9F7F2" />
      <g clip-path="url(#clip1_0_1)">
        <g filter="url(#filter0_d_0_1)">
          <mask id="path-4-inside-1_0_1" fill="white">
            <path d="M28.8354 0.384521H3.16457C1.58491 0.384521 0.304344 1.6167 0.304344 3.13667V21.9353C0.304344 23.4553 1.58491 24.6875 3.16457 24.6875H28.8354C30.4151 24.6875 31.6956 23.4553 31.6956 21.9353V3.13667C31.6956 1.6167 30.4151 0.384521 28.8354 0.384521Z" />
          </mask>
          <path
            d="M28.8354 0.384521H3.16457C1.58491 0.384521 0.304344 1.6167 0.304344 3.13667V21.9353C0.304344 23.4553 1.58491 24.6875 3.16457 24.6875H28.8354C30.4151 24.6875 31.6956 23.4553 31.6956 21.9353V3.13667C31.6956 1.6167 30.4151 0.384521 28.8354 0.384521Z"
            fill="#F9F7F2"
            fill-opacity="0.9"
            stroke="#874439"
            stroke-width="2"
            mask="url(#path-4-inside-1_0_1)"
          />
          <path
            d="M7.66172 6.21729H11.4385C11.7775 6.21729 12.0973 6.34613 12.3014 6.56584L12.9488 7.26294C13.3561 7.70147 13.9958 7.96004 14.6757 7.96004H23.8478C24.4423 7.96004 24.9269 8.34953 24.9269 8.83265V17.9822C24.9269 18.4653 24.4423 18.8548 23.8478 18.8548H7.66172C7.06727 18.8548 6.58269 18.4653 6.58269 17.9822V7.0899C6.58269 6.60677 7.06727 6.21729 7.66172 6.21729Z"
            fill="#874439"
          />
          <path
            d="M19.3519 12.8033V14.025H17.6448V15.4097H16.1274V14.025H14.4202V12.8033H16.1274V11.4287H17.6448V12.8033H19.3519Z"
            fill="#F9F7F2"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_0_1"
        x="-3.29268"
        y="-2.2125"
        width="38.5853"
        height="31.497"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.79851" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_0_1"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_0_1"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_0_1">
        <rect
          width="1366"
          height="6126"
          fill="white"
          transform="translate(-571 -785)"
        />
      </clipPath>
      <clipPath id="clip1_0_1">
        <rect
          width="38"
          height="31"
          fill="white"
          transform="translate(-3 -2)"
        />
      </clipPath>
    </defs>
  </svg>
);
